/* tslint:disable: member-ordering */
import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';

import { UserActions } from './user.actions';
import { UserService } from './user.service';

import { AssessmentActions } from '../assessment';
import { SocketHandler } from "../../services";

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService,
    private userActions: UserActions,
    private socketHandler: SocketHandler
  ) { }

  @Effect() lockUser$ = this.actions$
    .ofType(AssessmentActions.LOCK_TEST)
    .do(() => {
      this.socketHandler.manuallyDisconnect();
    })
    .switchMap(() =>
      Observable.of(this.userActions.lockUser())
    );

  @Effect() login$ = this.actions$
    .ofType(UserActions.LOGIN)
    .map(action => action['payload'])
    .switchMap(({username, password}) =>
      this.userService.loginRequest$(false, username, password)
        .switchMap(res => res.success &&
          res.payload && res.payload.testMetaData && res.payload.user
          ? Observable.of(this.userActions.loginSuccess(res.payload))
          : Observable.of(this.userActions.loginFail(res.payload))
        )
    );

  @Effect() autoLogin$ = this.actions$
    .ofType(UserActions.AUTO_LOGIN)
    .map(action => action['payload'])
    .switchMap(({id}) =>
      this.userService.loginRequest$(true, id)
        .switchMap(res => res.success &&
          res.payload && res.payload.testMetaData && res.payload.user
          ? Observable.of(this.userActions.loginSuccess(res.payload))
          : Observable.of(this.userActions.loginFail(res.payload))
        )
    );

	@Effect({ dispatch: false }) setLanguage$ = this.actions$
		.ofType(UserActions.SET_LANGUAGE)
		.map(action => action['payload'])
		.distinctUntilChanged()
		.switchMap(lang => {
			// set global lang
			this.userService.setLanguage(lang);
			// update cookie
			//this.userService.setCookieLanguage(lang);
			return Observable.empty();
		});
}



// WEBPACK FOOTER //
// ./src/app/logics/user/user.effects.ts